import { useMutation } from "@apollo/client";
import { Modal, Notification } from "components";
import { dataTranslation } from "enhancers/withHooks";
import { cloneDeep, get, isEmpty, set } from "lodash";
import { showDependencyLoopDetectedModal } from "utils/showDependencyLoopDetectedModal";
import { showValidationFailedModal } from "utils/showValidationFailedModal";
const useCustomMutation = (api, props, mutationProps) => {
  const { setErrors, t } = props;
  return useMutation(api, {
    ...mutationProps,
    onError: (error) => {
      if (!mutationProps?.skipSetError) {
        if (error.networkError.statusCode === 422 && setErrors) {
          const errors = get(error, "networkError.result.errors");
          const fieldError = {};
          let __error__ = "";
          for (const e of errors) {
            const originalError = get(e, "extensions.originalError", null);
            if (!originalError) {
              continue;
            }

            if (originalError instanceof Array) {
              for (const { field, message } of originalError) {
                if (field) {
                  set(fieldError, field, message);
                } else {
                  __error__ += `${message}\n`;
                }
              }
            }
          }
          setErrors({ ...fieldError, __error__ });

          console.log(
            get(
              error,
              "networkError.result.errors[0].extensions.originalError[0].message"
            )
          );
          if (isEmpty(fieldError) && !mutationProps?.skipSnackbar)
            Notification.error(
              t(
                get(
                  error,
                  "networkError.result.errors[0].extensions.originalError[0].message",
                  "เกิดข้อผิดพลาดบางอย่าง โปรดติดต่อทีมงาน"
                )
              )
            );
        } else if (
          error.networkError.statusCode === 422 &&
          !mutationProps?.skipSnackbar
        ) {
          Notification.error(
            t(
              get(
                error,
                "networkError.result.errors[0].message",
                "เกิดข้อผิดพลาดบางอย่าง โปรดติดต่อทีมงาน"
              )
            )
          );
        } else if (error.networkError.statusCode === 460) {
          const networkResult = get(error, "networkError.result");
          const originalError =
            get(networkResult, "errors.0.extensions.originalError.0") ||
            get(networkResult, "errors.0.extensions.originalError");

          const plan = get(originalError, "plan");
          const transactionPlan = cloneDeep(plan);
          dataTranslation(transactionPlan);
          showDependencyLoopDetectedModal({
            transactionPlanName: transactionPlan.name,
            t,
          });
        } else if (error.networkError.statusCode === 462) {
          const networkResult = get(error, "networkError.result");
          const originalError =
            get(networkResult, "errors.0.extensions.originalError.0") ||
            get(networkResult, "errors.0.extensions.originalError");

          const versionName = get(originalError, "versionName");
          const errorsObj = get(originalError, "errors");

          if (versionName && errorsObj) {
            showValidationFailedModal({ versionName, errorsObj, t });
          } else if (!mutationProps?.skipSnackbar) {
            Notification.error(
              t(
                get(
                  error,
                  "networkError.result.errors[0].message",
                  "เกิดข้อผิดพลาดบางอย่าง โปรดติดต่อทีมงาน"
                )
              )
            );
          }
          return;
        } else if (error.networkError?.statusCode === 463) {
          Modal.alert({
            title: t("common.error") || "เกิดข้อผิดพลาด",
            children:
              t("client.error.notCurrentVersion") ||
              "เวอร์ชั่นที่กำลังแก้ไขไม่ใช่เวอร์ชั่นปัจจุบันกดตกลงเพื่อกลับสู่หน้ารายการ",
            hideCancelButton: true,
            okButtonLabel: t("client.error.close"),
            okButtonVariant: "outlined",
            onOk: () => {
              const disableFunc =
                mutationProps?.disablePreventLeaveDirtyForm ||
                props?.disablePreventLeaveDirtyForm;
              if (disableFunc) {
                disableFunc();
              }
              const tenantId = window.location.pathname.match(
                /^\/([^/]+)\//
              )?.[1];
              const path = tenantId
                ? `/${tenantId}/master_insurance_plan`
                : "/master_insurance_plan";
              window.location.href = path;
            },
          });
          return;
        }
      }

      if (mutationProps?.onError) {
        mutationProps.onError(error);
      } else {
        throw new Error(error.toString());
      }
    },
  });
};

export default useCustomMutation;
